import ClipList from 'components/clipList';
import ClipEditPage from 'views/content/clip/edit';
import {clipPermissions} from 'views/content/clip/permissions';
import {IRouteItem} from 'routes';

const paths = {
  clipListPage: '/clips',
  clipEditDetailsPageAlt: '/clips/:id',
  clipEditDetailsPage: '/clips/:id/details',
  clipEditSettingsPage: '/clips/:id/settings',
  clipEditMediaPage: '/clips/:id/media',
  clipEditCaptionsAudioPage: '/clips/:id/captions-audio',
  clipEditEpisodesPage: '/clips/:id/episodes',
};

const routes: IRouteItem[] = [
  {
    name: 'Content',
    icon: 'content',
    showInSideBar: true,
    requiredPermissions: [...clipPermissions.CLIP_VIEW.enabled],
    children: [
      {
        name: 'Clips',
        path: paths.clipListPage,
        component: ClipList,
        breadcrumb: {items: [{text: 'Clips', route: paths.clipListPage}]},
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
    ],
  },
  {
    name: 'Clip Edit',
    children: [
      {
        name: 'Clip Edit Detail',
        path: paths.clipEditDetailsPage,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Details', route: paths.clipEditDetailsPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
      {
        name: 'Clip Edit Detail',
        path: paths.clipEditDetailsPageAlt,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Details', route: paths.clipEditDetailsPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
      {
        name: 'Clip Edit Settings',
        path: paths.clipEditSettingsPage,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Settings', route: paths.clipEditSettingsPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
      {
        name: 'Clip Edit Media',
        path: paths.clipEditMediaPage,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Media', route: paths.clipEditMediaPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
      {
        name: 'Clip Edit Captions/Audio',
        path: paths.clipEditCaptionsAudioPage,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Captions & Audio', route: paths.clipEditCaptionsAudioPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
      {
        name: 'Clip Edit Episodes',
        path: paths.clipEditEpisodesPage,
        component: ClipEditPage,
        breadcrumb: {
          items: [
            {text: 'Clips', route: paths.clipListPage},
            {text: 'Clip Episodes', route: paths.clipEditEpisodesPage},
          ],
        },
        requiredPermissions: clipPermissions.CLIP_VIEW.enabled,
      },
    ],
  },
];

export default {
  paths,
  routes,
};
